import { parseNumberFilter, toFilterText } from '@/utils/filters';
import type {
  AppVersionCheckFilterValues,
  AppVersionCheckSearch,
} from '../types/appVersionCheck.types';

export function toFilterValues(search: AppVersionCheckSearch): AppVersionCheckFilterValues {
  return {
    appVersion: toFilterText(search.appVersion),
    companyId: toFilterText(search.companyId),
    departmentId: toFilterText(search.departmentId),
    reportingMemberId: toFilterText(search.reportingMemberId),
    divisionId: toFilterText(search.divisionId),
    districtId: toFilterText(search.districtId),
    thanaId: toFilterText(search.thanaId),
  };
}

export function toSearchFilters(filters: AppVersionCheckFilterValues): AppVersionCheckSearch {
  return {
    appVersion: filters.appVersion || undefined,
    companyId: parseNumberFilter(filters.companyId),
    departmentId: parseNumberFilter(filters.departmentId),
    reportingMemberId: parseNumberFilter(filters.reportingMemberId),
    divisionId: parseNumberFilter(filters.divisionId),
    districtId: parseNumberFilter(filters.districtId),
    thanaId: parseNumberFilter(filters.thanaId),
  };
}
